export function getPropertyRateDisplayPrice(rate: App.EnrichedPropertyRate): number {
  return rate.luxPlusTotals?.displayPrice ?? rate.totals.displayPrice
}

export function canShowCollapsedLeadPrice(rate: App.EnrichedPropertyRate | undefined): boolean {
  return !!rate && (
    !rate.includesFlights ||
    (typeof rate.cheapestFlightPrice === 'number' && rate.cheapestFlightPrice > 0)
  )
}
